import { DbMongoBaseInfos } from "./db-mongo-base-infos";

import { StorageType } from "./storage-type";
import { StorageContext } from "./storage-context";
import { StorageKind } from "./storage-kind";
import { IngestStorageEventsManagerType } from "./ingest-storage-events-manager-type";
import { DbStorageBaseInfos } from "./db-storage-base-infos";
import { DbStorageUncInfos } from "./db-storage-unc-infos";
import { DbStorageAsperaInfos } from "./db-storage-aspera-infos";
import { DbStorageSnsmInfos } from "./db-storage-snsm-infos";
import { DbStorageFtpInfos } from "./db-storage-ftp-infos";
import { DbStorageDivaInfos } from "./db-storage-diva-infos";
import { DbStorageAmazonS3Infos } from "./db-storage-amazon-s3-infos";
import { ObjectType } from "./object-type";

export class DbStorageInfos extends DbMongoBaseInfos {
  enabled: boolean = true;
  isilonLocalAccountCreationSupport: boolean = false;
  allowDelete: boolean = false;
  platformIds: number[] | null = [];
  type: StorageType = StorageType.UNC;
  context: StorageContext = StorageContext.Remote;
  kind: StorageKind = StorageKind.External;
  eventsManagerType: IngestStorageEventsManagerType = IngestStorageEventsManagerType.FileSystemScanner;
  name: string | null = null;
  permChown: string | null = null;
  permChmod: number | null = 0;
  emails: string[] | null = null;
  storage:
    | DbStorageBaseInfos
    | DbStorageUncInfos
    | DbStorageAsperaInfos
    | DbStorageAsperaInfos
    | DbStorageSnsmInfos
    | DbStorageFtpInfos
    | DbStorageDivaInfos
    | DbStorageAmazonS3Infos
    | null = null;
  objectTypes: ObjectType[] | null = [];

  constructor(init?: Partial<DbStorageInfos>) {
    super();
    Object.assign(this, init);
  }
}
